import React from "react";

export const MagnifyingGlassIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12">
      <path
        fill="#7F869B"
        fillRule="evenodd"
        d="M1.108 5.292a4.184 4.184 0 1 1 8.368 0 4.184 4.184 0 0 1-8.368 0M5.292 0a5.292 5.292 0 1 0 2.942 9.692l2.097 2.14a.56.56 0 0 0 .8-.784L9.095 8.972A5.292 5.292 0 0 0 5.292 0"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
